const localization = {
  en: {
    home: 'Home',
    myHealth: 'My Health',
    appointments: 'Appointments',
    locations: 'Locations',
    messages: 'Messages'
  },
  es: {
    home: 'Inicio',
    myHealth: 'Mi Salud',
    appointments: 'Citas',
    locations: 'Ubicaciones',
    messages: 'Mensajes'
  },
  keyMapping: {
    home: 'UFD_Home_Button',
    myHealth: 'UFD_My_Health_Button',
    appointments: 'UFD_Appointments_Button',
    locations: 'UFD_Location_Button',
    messages: 'UFD_Messages_Button'
  }
}

export default localization
